import {
  faCompass,
  faHome,
  faMap,
} from '@fortawesome/free-solid-svg-icons';

// Same tabs the classic Header offers logged-out visitors — the mobile
// bottom bar must survive the reading-nav swap (it IS the app experience).
export const LOGGED_OUT_NAV_ITEMS = [
  { icon: faHome, title: 'feed' },
  { icon: faMap, title: 'map' },
  { icon: faCompass, title: 'destinations' },
];
export const NAV_ROUTES = ['/explore', '/map', '/destinations'];
